import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { CheckCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button } from 'react-bootstrap';
import { addStyle } from 'react-bootstrap/lib/utils/bootstrapUtils';

const defaultPlaceholder = "Search...";

addStyle(Button, 'outline-secondary');

const SearchFilter = ({ filter, onChange, showSearch, inputRef }) =>
  showSearch ? (
    <input
      type="text"
      placeholder="Search..."
      value={filter ? filter.value : ""}
      onChange={(e) => onChange(e.target.value)}
      ref={inputRef}
    />
  ) : null;

SearchFilter.propTypes = {
  filter: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  showSearch: PropTypes.bool,
  inputRef: PropTypes.oneOfType([
    PropTypes.func, 
    PropTypes.shape({ current: PropTypes.any })
  ])
};

export const getColumns = (state, toggleSearch, showDetails, checkBoxClicked, handleAll, inputRef) => [
  {
    Header: (
      <Tooltip placement="bottom" title="Select All">
        <Button bsStyle="outline-secondary" onClick={handleAll}>
          <CheckCircleOutlined />
        </Button>
      </Tooltip>
    ),
    Cell: (row) => {
      let data = row.original;
      return (
        <div className="custom-table" style={{ textAlign: "center" }}>
          <input
            type="checkbox"
            className="checkbox"
            checked={state.resultCheckList.includes(data.nodeId)}
            style={{ float: "center" }}
            onChange={() => checkBoxClicked(data, row.index)}
          />
        </div>
      );
    },
    width: 70,
    filterable: false,
  },
  {
    accessor: "DocumentType",
    Header: () => (
      <span>
        Document Type
        <Tooltip title="Search">
          <SearchOutlined style={{ cursor: "pointer", marginLeft: "1em" }} onClick={toggleSearch} />
        </Tooltip>
      </span>
    ),
    filterPlaceholder: defaultPlaceholder,
    filterable: true,
    Cell: (row) => (
      <div>
        <button
          type="button"
          style={{ textDecoration: "underline", background: "none", border: "none", color: "#007bff", cursor: "pointer", padding: 0 }}
          onClick={() => showDetails(row.original)}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              showDetails(row.original);
            }
          }}
        >
          {row.original.DocumentType}
        </button>
      </div>
    ),
    Filter: (props) => SearchFilter({ ...props, showSearch: state.showSearch, inputRef }),
  },
  {
    accessor: "docName",
    Header: () => (
      <span>
        Document Name
        <Tooltip title="Search">
          <SearchOutlined style={{ cursor: "pointer", marginLeft: "1em" }} onClick={toggleSearch} />
        </Tooltip>
      </span>
    ),
    filterable: true,
    filterPlaceholder: defaultPlaceholder,
    width: 250,
    Cell: (val) => (
      <div className="showfullString">
        <Tooltip placement="bottom" title={val.value}>
          {val.value}
        </Tooltip>
      </div>
    ),
    Filter: (props) => SearchFilter({ ...props, showSearch: state.showSearch, inputRef }),
  },
  {
    accessor: "InvoiceNumber",
    Header: () => (
      <span>
        Vendor Invoice #
        <Tooltip title="Search">
          <SearchOutlined style={{ cursor: "pointer", marginLeft: "1em" }} onClick={toggleSearch} />
        </Tooltip>
      </span>
    ),
    filterPlaceholder: defaultPlaceholder,
    filterable: true,
    Cell: row => {
        return (
            <span >{(row.value && row.value.length !== 0) ? row.value.toString() : ''}</span>
        )},
    Filter: (props) => SearchFilter({ ...props, showSearch: state.showSearch, inputRef }),
  },
  {
    accessor: "PONumber",
    Header: () => (
      <span>
        PO #
        <Tooltip title="Search">
          <SearchOutlined style={{ cursor: "pointer", marginLeft: "1em" }} onClick={toggleSearch} />
        </Tooltip>
      </span>
    ),
    filterPlaceholder: defaultPlaceholder,
    filterable: true,
    Filter: (props) => SearchFilter({ ...props, showSearch: state.showSearch, inputRef }),
  },
  {
    accessor: "OrderControlNumber",
    Header: () => (
      <span>
        OC #
        <Tooltip title="Search">
          <SearchOutlined style={{ cursor: "pointer", marginLeft: "1em" }} onClick={toggleSearch} />
        </Tooltip>
      </span>
    ),
    filterable: true,
    filterPlaceholder: defaultPlaceholder,
    Cell: row => {
        return (
            <div>
                <div>{row.original.OrderControlNumber ? row.original.OrderControlNumber.toString() : ''}</div>

            </div>
        )
    },
    Filter: (props) => SearchFilter({ ...props, showSearch: state.showSearch, inputRef }),
  },
  {
    accessor: "VoucherNumber",
    Header: () => (
      <span>
        Voucher #
        <Tooltip title="Search">
          <SearchOutlined style={{ cursor: "pointer", marginLeft: "1em" }} onClick={toggleSearch} />
        </Tooltip>
      </span>
    ),
    filterPlaceholder: defaultPlaceholder,
    filterable: true,
    Filter: (props) => SearchFilter({ ...props, showSearch: state.showSearch, inputRef }),
  },
  {
    accessor: "CheckNumber",
    Header: () => (
      <span>
        Check/ACH #
        <Tooltip title="Search">
          <SearchOutlined style={{ cursor: "pointer", marginLeft: "1em" }} onClick={toggleSearch} />
        </Tooltip>
      </span>
    ),
    filterPlaceholder: defaultPlaceholder,
    filterable: true,
    Filter: (props) => SearchFilter({ ...props, showSearch: state.showSearch, inputRef }),
  },
  {
    accessor: "PaymentDate",
    Header: () => (
      <span>
        Payment Date
        <Tooltip title="Search">
          <SearchOutlined style={{ cursor: "pointer", marginLeft: "1em" }} onClick={toggleSearch} />
        </Tooltip>
      </span>
    ),
    filterPlaceholder: defaultPlaceholder,
    filterable: true,
    Filter: (props) => SearchFilter({ ...props, showSearch: state.showSearch, inputRef }),
  },
  {
    accessor: "PaymentAmount",
    Header: () => (
      <span>
        Payment Amount
        <Tooltip title="Search">
          <SearchOutlined style={{ cursor: "pointer", marginLeft: "1em" }} onClick={toggleSearch} />
        </Tooltip>
      </span>
    ),
    filterPlaceholder: defaultPlaceholder,
    filterable: true,
    Filter: (props) => SearchFilter({ ...props, showSearch: state.showSearch, inputRef }),
  },
];

